<template>
  <v-card fluid class="wrapper d-flex flex-column ma-0 pa-4 fill-height">
    <AppBar
      :secondary="secondary"
      :id="itemID"
      :edit="isEditMode"
      :loader="isLoading"
      @click-save-and-new="handleSaveAndNew"
      @click-save-and-return="handleSaveAndReturn"
    />
    <v-divider color="grey" class="pa-0 ma-0 mt-4"></v-divider>
    <v-container class="pa-0 ma-0 flex-grow-1 overflow-y-auto">
      <NewForm
        :save-new="save"
        :save-return="saveReturn"
        :edit="isEditMode"
        :clear="clearForm"
        @clear-form="FormIsClear"
        @again-ready-to-save="handleSave"
        @is-loading="handleIsLoading"
        style="max-height: calc(100vh - 240px); overflow-y: auto; max-width: 100%"
      />
    </v-container>
    <v-divider color="grey" class="pa-0 ma-0"></v-divider>
    <ActionSection
      style="max-height: 80px; overflow-y: auto; flex-shrink: 0"
      :secondary="secondary"
      class="mt-4"
      :edit="isEditMode"
      :loader="isLoading"
      @click-save-and-new="handleSaveAndNew"
      @click-save-and-return="handleSaveAndReturn"
      @clear-form="handleClearForm"
    />
    <PermissionDialog
      :askPerm="askPerm"
      :txtPerm="$t('are-you-sure-clear-form')"
      :detailPerm="detailPerm"
      @accept="handleAccept"
      :permType="true"
      :dialogWidth="320"
      @deny="askPerm = false"
    />
  </v-card>
</template>

<script>
import NewForm from "@/views/dashboard/pages/payroll/commandments/partial/NewForm.vue";
import AppBar from "@/views/dashboard/pages/payroll/commandments/partial/AppBar.vue";
import ActionSection from "@/views/dashboard/pages/payroll/commandments/partial/ActionSection.vue";
import PermissionDialog from "@/views/dashboard/pages/invoice/CashRegister/partial/PermissionDialog.vue";

export default {
  name: "commandment",
  components: {
    NewForm,
    AppBar,
    ActionSection,
    PermissionDialog,
  },
  data: () => ({
    secondary: false,
    save: false,
    saveReturn: false,
    isEditMode: false,
    askPerm: false,
    clearForm: false,
    itemID: null,
    isLoading: false,
    detailPerm: "",
  }),
  created() {
    if (this.$route.path.includes("/create")) {
      this.secondary = true;
      this.isEditMode = false;
    }
    if (this.$route.path.includes("/edit")) {
      this.itemID = this.$route.params.id;
      this.isEditMode = true;
      this.secondary = true;
      this.getItemData(this.$route.params.id);
    }
  },
  mounted() {},
  methods: {
    handleIsLoading(val) {
      this.isLoading = val;
    },
    handleClearForm() {
      this.askPerm = true;
    },
    handleSaveAndNew() {
      this.save = true;
    },
    handleSaveAndReturn() {
      this.isLoading = true;
      this.saveReturn = true;
    },
    handleSave() {
      this.save = false;
      this.saveReturn = false;
    },
    getItemData(id) {},
    handleAccept() {
      this.clearForm = true;
    },
    FormIsClear() {
      this.clearForm = false;
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: calc(100vh - 100px);
  width: 100%;
}
::-webkit-scrollbar {
  display: none;
}
::v-deep .v-application--wrap {
  min-height: 0;
}
</style>
